export default `uniform float uFlatStart;
uniform float uFlatEnd;
attribute vec4 aPacked;
varying vec3 vWorldPos;
varying float vAO;
varying float vScale;
flat varying float vFace;`